<vn-swiper [swiperOptions]="swiperConfig" [swiperClass]="[item.class, 'swiper--buttons-sm swiper--buttons-shadow']">
    @for (child of item.children | slice: 0 : 5; track trackByProp($index, child)) {
        <div class="swiper-slide am-slider-item">
            <ng-container *vnDynamicComponent="getItemComponent(child.type); attr: { item: child }" />
        </div>
    }
</vn-swiper>
<div class="am-slider-anchor" [vnElementKey]="VanillaElements.ACCOUNT_MENU_SLIDER_ANCHOR"></div>
